<template>
    <div class="p-4 border-2 border-sky-500  rounded shadow bg-white">
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center">
            <div class="flex-1 text-lg font-semibold text-gray-700">
                It cost <span class="text-gray-900 text-xl italic">${{ price }}</span> to publish your jobs post.
            </div>
            <div v-if="form.hasErrors" class="sm:hidden">
                <small v-for="error in form.errors" class="form-error">{{ error }} </small>
            </div>
            <div ref="templateForm" class="relative z-10"></div>
        </div>
        <div v-if="form.hasErrors" class="hidden sm:block">
            <small v-for="error in form.errors" class="form-error">{{ error }} </small>
        </div>
    </div>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import useForm from '../functions/useForm';

const props = defineProps({
    urls: {
        type: Object,
        required: true,
    },
    jobPost: {
        type: String,
        required: true,
    },
    price: {
        type:String,
        required: true,
    }
})

const templateForm = ref(null)
const form = useForm({
    'job_post': props.jobPost,
})

let captureForm

onMounted(() => {
    paypal.Buttons({
        onClick(data, actions) {
            return new Promise(resolve => {
                form.post(props.urls.create_order, {
                    onSuccess: data => {
                        captureForm = useForm(data)
                        resolve(actions.resolve())
                    },
                    onError: () => {
                        resolve(actions.reject())
                    },
                })
            })
        },
        createOrder() {
           return captureForm.paypal_id
        },
        onApprove() {
            captureForm.post(props.urls.capture_order, {
                onSuccess: () => window.location.reload()
            })
        }
    }).render(templateForm.value);
})
</script>